/** A profile catalogue is fulfilment detail, not another Proposal answer.
 * Choosing the quoted service (or declining it) answers the option group. */
export function unansweredOptionGroups(groups:{key:string}[],choices:Record<string,{optionIndex:number}>):string[]{
 return groups.filter(group=>choices[group.key]===undefined).map(group=>group.key);
}
